module.exports = __webpack_public_path__ + "static/img/cha-page-07.ec82161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha-page-07.png
// module id = 1YS9
// module chunks = 1